import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";

export interface GetFeaturedProductsApiParameter extends ApiParameter, HasPagingParameters {
    id?: string;
    numberOfReturnedItem?: number;
    type?: string;
}

const featuredproductUrl = "/api/custom/featuredproduct";

export function getFeaturedProducts(parameter: GetFeaturedProductsApiParameter) {
    return get<any>(`${featuredproductUrl}/${parameter.type}/${parameter.id}`);
}
